//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from '../translations';
import Vue from 'vue'

import {brandDetector} from '@/brands';

let brandStyles = brandDetector();

let lang;

console.log(window.localStorage.getItem('_idIdiomaPreferido'));

if(window.localStorage.getItem('_idIdiomaPreferido')){
  lang = window.localStorage.getItem('_idIdiomaPreferido');
}else if(brandStyles.languagebydefault && !lang){
  lang = brandStyles.languagebydefault;
}else{
  lang = "es";
}




Vue.use(VueI18n);


const i18n = new VueI18n({
	locale: lang,
	messages,
});
//.IDIOMAS

export default i18n;


// WEBPACK FOOTER //
// ./submodules/dotia-base-fp/src/i18n/index.js